import {createContext} from 'react';

const TranscriptContext = createContext(null);

export default TranscriptContext;
